var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "testimonial_column", style: _vm.cssVars },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            staticClass: "testimonial_column__inner",
            class: {
              one: _vm.parsedTestimonials.length === 1,
              two: _vm.parsedTestimonials.length === 2,
              three: _vm.parsedTestimonials.length === 3,
              four: _vm.parsedTestimonials.length === 4,
            },
          },
          _vm._l(_vm.parsedTestimonials, function (testimonial, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "testimonial_column__inner__text",
                style: {
                  "--background-colour": testimonial.background_colour,
                  "--text-colour": testimonial.quote_colour,
                  "--title-colour": testimonial.title_colour,
                  "--tile-border":
                    testimonial.background_colour === "#fff" ? "1px" : "0px",
                },
                attrs: {
                  "data-aos": "fade-up",
                  "data-aos-duration": "300",
                  "data-aos-offset": 50,
                  "data-aos-delay": index * 50,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "content_container" },
                  [
                    _c("quote-icon"),
                    _vm._v(" "),
                    testimonial.quote
                      ? _c("div", {
                          staticClass: "text",
                          domProps: { innerHTML: _vm._s(testimonial.quote) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    testimonial.quote_source
                      ? _c("h5", {
                          domProps: {
                            innerHTML: _vm._s(testimonial.quote_source),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    testimonial.logo
                      ? _c("img", {
                          attrs: {
                            src: testimonial.logo.url,
                            alt: testimonial.quote_source,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }